import GoodsItem from './GoodsItem'
export default GoodsItem
